import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Explore from "@/pages/Explore";
import LegalPage from "@/pages/LegalPage";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Overview from "@/admin/Overview";
import Documents from "@/admin/Documents";
import Rules from "@/admin/Rules";
import Reconciliation from "@/admin/Reconciliation";
import Analyzer from "@/admin/Analyzer";
import Golden from "@/admin/Golden";
import Versions from "@/admin/Versions";
import Orders from "@/admin/Orders";
import Reports from "@/admin/Reports";
import Promos from "@/admin/Promos";
import Receipt from "@/pages/Receipt";
import Discover from "@/pages/Discover";
import ContentEditor from "@/admin/ContentEditor";
import { Messages, AuditLog } from "@/admin/Logs";
import Waitlist from "@/admin/Waitlist";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="bottom-right" richColors />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/receipt" element={<Receipt />} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/privacy" element={<LegalPage field="privacy" title="Privacy Policy" />} />
        <Route path="/terms" element={<LegalPage field="terms" title="Terms and Conditions" />} />
        <Route path="/refund" element={<LegalPage field="refund" title="Refund and Cancellation Policy" />} />
        <Route path="/disclaimer" element={<LegalPage field="disclaimer" title="Interpretation Disclaimer" />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Overview />} />
          <Route path="documents" element={<Documents />} />
          <Route path="rules" element={<Rules />} />
          <Route path="reconciliation" element={<Reconciliation />} />
          <Route path="analyzer" element={<Analyzer />} />
          <Route path="golden" element={<Golden />} />
          <Route path="versions" element={<Versions />} />
          <Route path="orders" element={<Orders />} />
          <Route path="reports" element={<Reports />} />
          <Route path="promos" element={<Promos />} />
          <Route path="content" element={<ContentEditor />} />
          <Route path="waitlist" element={<Waitlist />} />
          <Route path="messages" element={<Messages />} />
          <Route path="audit" element={<AuditLog />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
